export const configurationColumnTableStableLoads = {
  column1: true /*required field*/,
  product: true /*required field*/,
  column4: true /*required field*/,
  type: true,
  column11: true,
  column3: true,
  column2: true,
  temperature: false,
  numGrease: false,
  proteins: false,
  somaticCells: false,
  bacterialCharge: false,
  casein: false,
  lactose: false,
  cryoscopicIndex: false,
  skimmedDryResidue: false,
  urea: false,
  aflatoxinsELISA: false,
  aflatoxinsHPLC: false,
  inhibitorySubstances: false,
  lacticAcid: false,
};
